module.exports = __webpack_public_path__ + "media/Seher-6s.73da68a6.mp4";